import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { CaisseStateService } from '../caisse/caisse-state.service';

@Component({
  selector: 'app-close-caisse',
  templateUrl: './close-caisse.component.html',
  styleUrls: ['./close-caisse.component.scss'],
  providers: [DatePipe],
})
export class CloseCaisseComponent implements OnInit {
  constructor(
    public route: ActivatedRoute,
    public generalService: GeneralService,
    public router: Router,
    private CaisseStateService: CaisseStateService
  ) {}

  codeCaisse = this.generalService.codeCaisse;
  CashD_Id;
  dsJourner;
  dsReglement;
  dsReglementInit;
  CashR_Type = [];
  exist = true;
  saved = false;
  mode: string;
  async ngOnInit() {
    // this.generalService.rechercheTable('DiverSys', 'trpos').subscribe((res) => {
    //   this.generalService.CashR_Type = res;

    // });
    if (!this.generalService.CashR_Type)
      this.generalService.CashR_Type = await this.generalService
        .rechercheTable('DiverSys', 'trpos')
        .toPromise();
    this.generalService.CashR_Type.forEach((type) => {
      this.CashR_Type.push({
        DiverSys_Libelle: type.DiverSys_Libelle,
        Diversys_Index: type.Diversys_Index,
        total: 0,
        totalCaisse: 0,
      });
    });

    this.readParamUrl();
  }
  getTotalServeur(): number {
    return this.CashR_Type.reduce((a, b) => a + b.total, 0);
  }
  getTotal(): number {
    return this.CashR_Type.reduce((a, b) => a + b.totalCaisse, 0);
  }
  goToCaisse() {
    this.router.navigate(['/avt/caisse']);
  }
  clotuer() {
    // if(this.totalChequeCaisse != this.totalCheque || this.totalEspecesCaisse != this.totalEspeces || this.totalTicketCaisse != this.totalTicket || this.totalTPECaisse != this.totalTPE)
    //   this.generalService.dialogSuccess("Les totaux entrés sont invalide",false)
    var condition = true;
    this.CashR_Type.forEach((reglement) => {
      if (
        reglement.Diversys_Index != 0 &&
        reglement.totalCaisse != reglement.total
      )
        condition = false;
    });
    if (this.dsJourner && this.dsReglementInit && condition) {
      if (condition) {
        this.exist = false;
        this.dsJourner.CashD[0].CashD_DateC = new Date();
        this.dsJourner.CashD[0].CashD_MRecette = this.getTotal();
        var compte = this.generalService.CashR_Type.length;
        this.generalService
          .enregisterTable(this.dsJourner)
          .subscribe((data) => {
            for (let i = 0; i < this.generalService.CashR_Type.length; i++) {
              var ds = JSON.parse(JSON.stringify(this.dsReglementInit));
              ds.CashDR[0].DocCashR_Type = this.CashR_Type[i].Diversys_Index;
              ds.CashDR[0].CashDR_MontantS = this.CashR_Type[i].total;
              ds.CashDR[0].CashDR_MontantE =
                this.CashR_Type[i].total - this.CashR_Type[i].totalCaisse;
              ds.CashDR[0].CashDR_Montant = this.CashR_Type[i].totalCaisse;
              this.generalService.enregisterTable(ds).subscribe((data) => {
                this.generalService.dialogSuccess('Journée clôturer', true);
                compte--;
                this.CaisseStateService.CaisseComponent = null;
                if (compte == 0) {
                  this.exist = true;
                  this.saved = true;
                }
              });
            }
          });
      } else
        this.generalService.dialogSuccess(
          'Seul le menton du caisse peut avoir une différence autre que 0',
          false
        );
    }
  }
  init() {
    this.getDsCloture();
    this.getDsReglement();
  }
  getDsCloture() {
    this.generalService
      .rechercheTable('ds/formdata?code=CashD&val=' + this.CashD_Id)
      .subscribe((data) => {
        this.dsJourner = data;
      });
  }
  getDsReglement() {
    this.generalService
      .rechercheTable('ds/formdata?code=CashDr')
      .subscribe((data) => {
        this.dsReglementInit = data;
      });
    this.generalService
      .rechercheTable('ds/formdata?code=CashDr&val=' + this.CashD_Id)
      .subscribe((data) => {
        this.dsReglement = data;
        this.CashR_Type.forEach((type) => {
          var reglement = this.dsReglement.CashDR.find((reg) => {
            return reg.DocCashR_Type == type.Diversys_Index;
          });
          if (reglement) type.total = reglement.CashDR_Montant;
        });
      });
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.CashD_Id = params['param'];
      this.mode = params['mode'];
      this.init();
    });
  }
}
